// src/components/Footer.jsx
import React from "react";
import "./Footer.css"; // ✅ CSS ko import karo

const Footer = () => {
  return (
    <footer className="footer">
      <p>2025 © Ignite | CodePK Programming Competition</p>
    </footer>
  );
};

export default Footer;
